import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface SecondaryIconButtonProps {
  height?: number;
  icon?: string;
  iconSize?: number;
  width?: number;
}

const SecondaryIconButton: FunctionComponent<SecondaryIconButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const { height, style, width, ...baseButtonProps } = props;
  const updatedStyles = (height || width) && {
    ...style,
    ...height && { height: `${height}px` },
    ...width && { minWidth: `${width}px` },
  };
  const baseProps = {
    ...baseButtonProps,
    ...updatedStyles && { style: updatedStyles },
    styleClassNames,
    variantName: 'secondary-icon',
  };

  return <BaseButton {...baseProps} />;
};

export default SecondaryIconButton;
